export default __webpack_public_path__ + "static/media/khojhome.f31772e2.png";